<div class="borrower-request-page">
    <div class="page-header">
        <h1>Requests and Authorizations</h1>
    </div>

    <div class="tables-container">
        <!-- Transaction Request Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Requests</h2>
            </div>

            <app-borrower-transaction-requests-table></app-borrower-transaction-requests-table>
        </div>

        <!-- Authorization Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Authorizations</h2>
            </div>

            <app-borrower-authorizations-table></app-borrower-authorizations-table>
        </div>
    </div>
</div>
